import { LogManager } from '../../../common/port/log/log.manager.port';
import { AppMetricsTotalWholeTeamMapper } from '../../../infrastructure/mappers/team-metrics/app-metrics-total-whole-team.mapper';
import { GetAppMetricsTotalsWholeTeamRequestDto } from '../../dtos/team-metrics/get-app-metrics-totals-whole-team.request.dto';
import { GetAppMetricsTotalsWholeTeamResponseDto } from '../../dtos/team-metrics/get-app-metrics-totals-whole-team.response.dto';
import { GetAppMetricsTotalWholeTeamQuery } from '../../queries/team-metrics/get-app-metrics-totals-whole-team.query';

export class GetAppMetricsTotalWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsTotalWholeTeamQuery,
    protected readonly mapper: AppMetricsTotalWholeTeamMapper
  ) {}

  async get(
    props: GetAppMetricsTotalsWholeTeamRequestDto
  ): Promise<GetAppMetricsTotalsWholeTeamResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `AppMetricsTotalWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
